import { useQuery } from "@tanstack/react-query";
import { MinusCircle } from "lucide-react";
import React from "react";

import { getPosClient } from "../../lib/api";
import { lookupMethodByTypeSubtype, resolveMethodIcon } from "../../lib/payment-methods";
import { useDarkMode } from "../../lib/use-dark-mode";
import { cn } from "../../lib/utils";

interface MethodIconForTypeProps {
  readonly paymentType: string;
  readonly paymentSubtype: string | null;
  readonly locationId?: string | null;
  readonly className?: string;
}

export function MethodIconForType({
  paymentType,
  paymentSubtype,
  locationId = null,
  className = "h-3.5 w-3.5",
}: MethodIconForTypeProps): React.ReactElement {
  const isDark = useDarkMode();

  const railsQuery = useQuery({
    enabled: locationId != null,
    queryKey: ["payment-rails", locationId],
    queryFn: () => getPosClient().getLocationPaymentRails(locationId!),
    staleTime: 5 * 60_000,
  });

  const rails = railsQuery.data?.rails ?? [];
  const rail =
    lookupMethodByTypeSubtype(rails, paymentType, paymentSubtype) ??
    (paymentSubtype === null ? (rails.find((r) => r.payment_type === paymentType) ?? null) : null);

  if (!rail) {
    return <MinusCircle className={cn(className)} aria-hidden={true} />;
  }

  const resolved = resolveMethodIcon(rail, isDark);
  if (typeof resolved === "string") {
    return <img src={resolved} className={cn(className)} aria-hidden={true} alt="" />;
  }
  const Icon = resolved;
  return <Icon className={cn(className)} aria-hidden={true} />;
}
